import { IFilter } from "@saleor/components/Filter";
import { AutocompleteFilterOpts, FilterOpts, MinMax } from "@saleor/types";
import {
  createAutocompleteField,
  createDateField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum VoucherReportsFilterKeys {
  brand = "brand",
  mall = "mall",
  orderDate = "orderDate"
}

export interface VoucherReportsListFilterOpts {
  orderDate: FilterOpts<MinMax>;
  brand: FilterOpts<string[]> & AutocompleteFilterOpts;
  mall: FilterOpts<string[]> & AutocompleteFilterOpts;
}

const messages = defineMessages({
  brand: {
    defaultMessage: "Brand",
    description: "brand"
  },
  foodAndBeverages: {
    defaultMessage: "Food and Beverages",
    description: "Food and Beverages"
  },
  generalMerchandise: {
    defaultMessage: "General Merchandise",
    description: "general merchandise"
  },
  mall: {
    defaultMessage: "Mall",
    description: "mall branch"
  },
  orderDate: {
    defaultMessage: "Start & End Dates",
    description: "Order Date"
  },
  tenant: {
    defaultMessage: "Tenant Type",
    description: "tenant type"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: VoucherReportsListFilterOpts
): IFilter<VoucherReportsFilterKeys> {
  return [
    {
      ...createDateField(
        VoucherReportsFilterKeys.orderDate,
        intl.formatMessage(messages.orderDate),
        opts.orderDate.value
      ),
      active: opts.orderDate.active
    },
    {
      ...createAutocompleteField(
        VoucherReportsFilterKeys.brand,
        intl.formatMessage(messages.brand),
        opts.brand.value,
        opts.brand.displayValues,
        true,
        opts.brand.choices,
        {
          hasMore: opts.brand.hasMore,
          initialSearch: "",
          loading: opts.brand.loading,
          onFetchMore: opts.brand.onFetchMore,
          onSearchChange: opts.brand.onSearchChange
        }
      ),
      active: opts.brand.active
    },
    {
      ...createAutocompleteField(
        VoucherReportsFilterKeys.mall,
        intl.formatMessage(messages.mall),
        opts.mall.value,
        opts.mall.displayValues,
        true,
        opts.mall.choices,
        {
          hasMore: opts.mall.hasMore,
          initialSearch: "",
          loading: opts.mall.loading,
          onFetchMore: opts.mall.onFetchMore,
          onSearchChange: opts.mall.onSearchChange
        }
      ),
      active: opts.mall.active
    }
  ];
}
